const renunciasRRHHRouter = [
  {
    path: "/solicitudes/renuncias",
    name: "listado-renuncias",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_LISTAR_PROCESOS",
    },
    component: () => import(/* webpackChunkName: "renuncias-listado" */ "./listadoRenuncias.vue"),
  },
  {
  path: "/solicitudes/renuncias/DINARH",
    name: "listado-renuncias-dinarh",
    component: () => import(/* webpackChunkName: "renuncias-listado" */ "./listadoRenunciasDINARH.vue"),
  },
  {
    path: "/solicitudes/renuncias/renuncia-portal-empleado/:idTramite/:idPuestoEmpleado/:estado",
    name: "renuncia-portal-empleado",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_VER_DETALLE",
    },
    component: () => import(/* webpackChunkName: "renuncias-vistas" */ "./views/PortalEmpleadoRenunciaView.vue"),
  },
  {
    path: "/solicitudes/renuncias/renuncia-jefe-inmediato/:idTramite/:idPuestoEmpleado/:estado",
    name: "renuncia-jefe-inmediato",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_JEFE_APROBAR",
    },
    component: () => import(/* webpackChunkName: "renuncias-vistas" */ "./views/JefeInmediatoRenunciaView.vue"),
  },
  {
    path: "/solicitudes/renuncias/renuncia-rrhh/:idTramite/:idPuestoEmpleado/:estado", 
    name: "renuncia-rrhh",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_RRHH_CREAR_ACUERDO",
    },
    component: () => import(/* webpackChunkName: "renuncias-vistas" */ "./views/RecursosHumanosRenunciaView.vue"),
  },
  {
    path: "/solicitudes/renuncias/renuncia-titular/:idTramite/:idPuestoEmpleado/:estado",
    name: "renuncia-titular",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_TITULAR_FIRMAR_ACUERDO",
    },
    component: () => import(/* webpackChunkName: "renuncias-vistas" */ "./views/TitularRenunciaView.vue"),
  },
  {
    path: "/solicitudes/renuncias/renuncia-planilla/:idTramite/:idPuestoEmpleado/:estado",
    name: "renuncia-planilla",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_PLANILLA_CONFIRMAR",
    },
    component: () => import(/* webpackChunkName: "renuncias-vistas" */ "./views/PlanillaRenunciaView.vue"),
  },
  {
    path: "/solicitudes/renuncias/renuncia-ufi/:idTramite/:idPuestoEmpleado/:estado",
    name: "renuncia-ufi",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_UFI_CONFIRMAR_SUSPENSION",
    },
    component: () => import(/* webpackChunkName: "renuncias-vistas" */ "./views/UnidadFinancieraRenunciaView.vue"),
  },
//   {
//     path: "/acciones-movimientos/renuncias/detalle/empleado/:id_persona/renuncia/:id_renuncia/empleado-puesto/:id_empleado_puesto",
//     name: "renuncias.detalle",
//     component: () => import(/* webpackChunkName: "renuncias" */ "./views/detalle.vue"),
//   }
];

export default renunciasRRHHRouter;